import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties('CREATE_FAVOURITE', 'DELETE_FAVOURITE');
